import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

import { NewHeader } from './new_header'

const ContactSales = withSafeSuspense(lazy(async () => ({ default: (await import('./contact_sales')).Routes })))
const BillingPage = withSafeSuspense(lazy(async () => ({ default: (await import('./billing_page')).BillingPage })))
const TrialExtension = withSafeSuspense(lazy(async () => ({ default: (await import('./trial_extension')).TrialExtension })))

export const Billing = ({ match }) => (
  <>
    <NewHeader />
    <Switch>
      <Route path={`${match.url}/contact_sales`} component={ContactSales} />
      <Route path={`${match.url}/trial_extension`} component={TrialExtension} />
      <Route path={match.url} component={BillingPage} />
    </Switch>
  </>
)
